/**
 * Payer Connections — API surface (AC-2, AC-4, AC-9).
 *
 * Read-only by construction: this module exposes exactly two generated GET
 * endpoints and no mutation. `sync-all` is deliberately absent — Stedi is
 * the source of truth for this release and the section persists nothing
 * (PRD Q2), so nothing here can write.
 *
 * Only friendly hook names are exported, per src/features/README.md.
 *
 * No `enhanceEndpoints` call: this feature adds no tags and needs no cache
 * behaviour of its own, and a second enhancement chain over the generated
 * claims/enrollments apis (which `features/billing-readiness` and
 * `features/enrollments` already enhance) is enough extra type inference to
 * push `tsc` past its heap. AC-2's freshness comes from
 * `refetchOnMountOrArgChange` plus an `isFetching`-gated skeleton, so a
 * revisit shows the skeleton rather than the previous visit's rows under a
 * stale "Checked with the clearinghouse at" time.
 */

import { enhancedApi as claimsGeneratedApi } from '@store/generated/claims';
import { enhancedApi as enrollmentsGeneratedApi } from '@store/generated/enrollments';

export const { useGetV2ProviderEnrollmentsLiveQuery: usePayerConnectionsLiveQuery } =
  enrollmentsGeneratedApi;

/** The provider claims list, used only for its `total` (AC-4 / Q9). */
export const { useGetV2ProviderClaimsQuery: useProviderClaimsQuery } = claimsGeneratedApi;
